var _g, _g2, _g3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoldCoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ddn_2319_56035)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.2955 32.1028C64.2955 49.2804 50.3703 63.2057 33.1927 63.2057C16.0151 63.2057 2.08984 49.2804 2.08984 32.1028C2.08984 14.9252 16.0151 1 33.1927 1C50.3703 1 64.2955 14.9252 64.2955 32.1028Z",
    fill: "#EEBB4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.2955 32.1028C64.2955 49.2804 50.3703 63.2057 33.1927 63.2057C16.0151 63.2057 2.08984 49.2804 2.08984 32.1028C2.08984 14.9252 16.0151 1 33.1927 1C50.3703 1 64.2955 14.9252 64.2955 32.1028Z",
    fill: "#EEBB4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6348 1.09473C37.2813 1.22261 38.8914 1.48016 40.4561 1.85449L40.1631 3.08008C41.6965 3.44696 43.184 3.93188 44.6152 4.52539L45.0977 3.36133C46.6105 3.98868 48.063 4.73187 49.4443 5.58008L48.7852 6.6543C50.1204 7.47423 51.3866 8.3966 52.5723 9.41016L53.3906 8.45215C54.6292 9.51094 55.7839 10.6648 56.8428 11.9033L55.8848 12.7227C56.8984 13.9083 57.8206 15.1745 58.6406 16.5098L59.7148 15.8496C60.5633 17.2311 61.3061 18.6841 61.9336 20.1973L60.7695 20.6807C61.363 22.1119 61.849 23.5994 62.2158 25.1328L63.4404 24.8389C63.8148 26.4035 64.0723 28.0136 64.2002 29.6602L62.9434 29.7578C63.0034 30.5312 63.0342 31.3132 63.0342 32.1025C63.0342 32.892 63.0035 33.6747 62.9434 34.4482L64.2002 34.5449C64.0723 36.1915 63.8148 37.8016 63.4404 39.3662L62.2158 39.0732C61.8489 40.6067 61.3631 42.0941 60.7695 43.5254L61.9326 44.0078C61.3053 45.5206 60.563 46.9733 59.7148 48.3545L58.6406 47.6953C57.8206 49.0306 56.8984 50.2967 55.8848 51.4824L56.8418 52.3008C55.7831 53.5392 54.6291 54.6932 53.3906 55.752L52.5723 54.7949C51.3865 55.8086 50.1205 56.7308 48.7852 57.5508L49.4443 58.625C48.0631 59.4732 46.6104 60.2154 45.0977 60.8428L44.6152 59.6797C43.184 60.2732 41.6965 60.7591 40.1631 61.126L40.4561 62.3506C38.8914 62.7249 37.2813 62.9825 35.6348 63.1104L35.5381 61.8535C34.7646 61.9136 33.9818 61.9443 33.1924 61.9443C32.4031 61.9443 31.6211 61.9136 30.8477 61.8535L30.75 63.1104C29.1035 62.9824 27.4933 62.725 25.9287 62.3506L26.2227 61.126C24.6893 60.7591 23.2017 60.2732 21.7705 59.6797L21.2871 60.8438C19.774 60.2162 18.321 59.4734 16.9395 58.625L17.5996 57.5508C16.2644 56.7308 14.9982 55.8085 13.8125 54.7949L12.9932 55.7529C11.7546 54.6941 10.6008 53.5394 9.54199 52.3008L10.5 51.4824C9.48644 50.2968 8.56407 49.0305 7.74414 47.6953L6.66992 48.3545C5.82172 46.9732 5.07853 45.5207 4.45117 44.0078L5.61523 43.5254C5.02173 42.0942 4.5368 40.6066 4.16992 39.0732L2.94434 39.3662C2.57 37.8016 2.31245 36.1914 2.18457 34.5449L3.44238 34.4482C3.38229 33.6747 3.35156 32.892 3.35156 32.1025C3.35157 31.3132 3.3823 30.5312 3.44238 29.7578L2.18457 29.6602C2.31248 28.0136 2.56998 26.4035 2.94434 24.8389L4.16992 25.1328C4.53677 23.5995 5.02178 22.1118 5.61523 20.6807L4.45117 20.1973C5.07866 18.6841 5.82152 17.2311 6.66992 15.8496L7.74414 16.5098C8.56414 15.1745 9.48635 13.9084 10.5 12.7227L9.54199 11.9043C10.601 10.6655 11.7554 9.51111 12.9941 8.45215L13.8125 9.41016C14.9982 8.39651 16.2643 7.47429 17.5996 6.6543L16.9395 5.58008C18.321 4.73168 19.774 3.98881 21.2871 3.36133L21.7705 4.52539C23.2017 3.93194 24.6893 3.44693 26.2227 3.08008L25.9287 1.85449C27.4933 1.48013 29.1035 1.22264 30.75 1.09473L30.8477 2.35254C31.6211 2.29245 32.4031 2.26173 33.1924 2.26172C33.9818 2.26172 34.7646 2.29245 35.5381 2.35254L35.6348 1.09473Z",
    stroke: "#FFEBB2",
    strokeWidth: 2.52356,
    strokeDasharray: "5.05 5.05"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_iin_2319_56035)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 33.1785,
    cy: 32.1004,
    r: 28.5793,
    transform: "rotate(180 33.1785 32.1004)",
    fill: "#005754"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33.1785,
    cy: 32.1004,
    r: 28.5793,
    transform: "rotate(180 33.1785 32.1004)",
    fill: "url(#paint0_linear_2319_56035)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_in_2319_56035)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.7011 36.8219H18.668V28.4235H33.7313V36.8219H47.7051V27.375",
    stroke: "#EBBD6A",
    strokeWidth: 2.08906
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ddn_2319_56035",
    x: 0.849095,
    y: 0.579407,
    width: 64.5624,
    height: 64.5584,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.168237,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_2319_56035"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.0630889,
    dy: 0.757067
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.504711
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2319_56035"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.168237,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect2_dropShadow_2319_56035"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.0630889,
    dy: 0.252356
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.126178
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_2319_56035",
    result: "effect2_dropShadow_2319_56035"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feTurbulence", {
    type: "fractalNoise",
    baseFrequency: "15.850643157958984 15.850643157958984",
    stitchTiles: "stitch",
    numOctaves: 3,
    result: "noise",
    seed: 2402
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "noise",
    type: "luminanceToAlpha",
    result: "alphaNoise"
  }), /*#__PURE__*/React.createElement("feComponentTransfer", {
    in: "alphaNoise",
    result: "coloredNoise1"
  }, /*#__PURE__*/React.createElement("feFuncA", {
    type: "discrete",
    tableValues: "1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 "
  })), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "shape",
    in: "coloredNoise1",
    result: "noise1Clipped"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgba(0, 0, 0, 0.08)",
    result: "color1Flood"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "noise1Clipped",
    in: "color1Flood",
    result: "color1"
  }), /*#__PURE__*/React.createElement("feMerge", {
    result: "effect3_noise_2319_56035"
  }, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shape"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "color1"
  })), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "effect3_noise_2319_56035",
    in2: "effect2_dropShadow_2319_56035",
    result: "effect3_noise_2319_56035"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_iin_2319_56035",
    x: 4.59766,
    y: 3.01873,
    width: 57.3494,
    height: 58.418,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.189267,
    dy: 0.757067
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.757067
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2319_56035"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.504711
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.757067
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_2319_56035",
    result: "effect2_innerShadow_2319_56035"
  }), /*#__PURE__*/React.createElement("feTurbulence", {
    type: "fractalNoise",
    baseFrequency: "15.850643157958984 15.850643157958984",
    stitchTiles: "stitch",
    numOctaves: 3,
    result: "noise",
    seed: 1911
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "noise",
    type: "luminanceToAlpha",
    result: "alphaNoise"
  }), /*#__PURE__*/React.createElement("feComponentTransfer", {
    in: "alphaNoise",
    result: "coloredNoise1"
  }, /*#__PURE__*/React.createElement("feFuncA", {
    type: "discrete",
    tableValues: "1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 "
  })), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "effect2_innerShadow_2319_56035",
    in: "coloredNoise1",
    result: "noise1Clipped"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgba(255, 190, 0, 0.2)",
    result: "color1Flood"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "noise1Clipped",
    in: "color1Flood",
    result: "color1"
  }), /*#__PURE__*/React.createElement("feMerge", {
    result: "effect3_noise_2319_56035"
  }, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "effect2_innerShadow_2319_56035"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "color1"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_in_2319_56035",
    x: 17.625,
    y: 27.375,
    width: 31.125,
    height: 10.6184,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.126178
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.274437
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2319_56035"
  }), /*#__PURE__*/React.createElement("feTurbulence", {
    type: "fractalNoise",
    baseFrequency: "15.850643157958984 15.850643157958984",
    stitchTiles: "stitch",
    numOctaves: 3,
    result: "noise",
    seed: 1911
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "noise",
    type: "luminanceToAlpha",
    result: "alphaNoise"
  }), /*#__PURE__*/React.createElement("feComponentTransfer", {
    in: "alphaNoise",
    result: "coloredNoise1"
  }, /*#__PURE__*/React.createElement("feFuncA", {
    type: "discrete",
    tableValues: "1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 "
  })), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "effect1_innerShadow_2319_56035",
    in: "coloredNoise1",
    result: "noise1Clipped"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgba(179, 40, 33, 0.25)",
    result: "color1Flood"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "noise1Clipped",
    in: "color1Flood",
    result: "color1"
  }), /*#__PURE__*/React.createElement("feMerge", {
    result: "effect2_noise_2319_56035"
  }, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "effect1_innerShadow_2319_56035"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "color1"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2319_56035",
    x1: 48.0774,
    y1: 6.90105,
    x2: 19.6605,
    y2: 59.2201,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.129808,
    stopColor: "#E39934"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.513763,
    stopColor: "#FFF3C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.966346,
    stopColor: "#EEBB4C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoldCoin);
export default __webpack_public_path__ + "static/media/gold-coin.30c59791c437ec0eab47c40f814425f0.svg";
export { ForwardRef as ReactComponent };